import HelpButton from '@/components/LayoutApp/HeaderBar/HelpButton'
import ChevronLeftButton from './ChevronLeftButton/ChevronLeftButton'

const DeliverOrderHeaderBar = () => (
  <header className="dark:shadow-none dark:border-b dark:border-gray-darkMode dark:bg-black-darkMode h-14 rounded-b-2xl fixed top-0 z-10 flex items-center justify-center w-full p-1 bg-white border-b">
    <section className="dark:text-white-darkMode flex flex-row items-center justify-between w-full max-w-3xl m-auto text-sm font-medium text-center text-gray-600">
      <ChevronLeftButton />
      <span className="text-lg font-semibold">Firma del Cliente</span>
      <HelpButton />
    </section>
  </header>
)
export default DeliverOrderHeaderBar
